import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgTagAlt = function SvgTagAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.353 11.878a3 3 0 010 4.242l-6.17 6.172a3 3 0 01-4.242 0l-11-11A2.978 2.978 0 01.062 9.17V2a2 2 0 012-2h7.169a2.978 2.978 0 012.122.878l11 11zm-7.586 9l6.172-6.172v.001a1 1 0 000-1.414l-11-11A1 1 0 009.231 2H2.562a.5.5 0 00-.5.5v6.67a1 1 0 00.291.708l11 11a1.025 1.025 0 001.414 0z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M6.06 7.499a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }));
};

export default SvgTagAlt;